import { render } from "./ImageModal.vue?vue&type=template&id=6dc514bf&scoped=true&ts=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=6dc514bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc514bf"]])

export default __exports__